const newcolor = {
  background: "black",
  color: "white",
};
const borderwhite = {
  border: "2px solid white",
};
const borderblack = {
  border: "1px solid black",
};

export { newcolor, borderwhite, borderblack };
